import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DziViewerComponent } from './dzi-viewer.component';
import { DziImageFiltersDirective } from './directives/dzi-image-filters/dzi-image-filters.directive';
import { DziKeyBindingsDirective } from './directives/dzi-keybindings/dzi-keybindings.directive';
import { DziMouseBindingsDirective } from './directives/dzi-mousebindings/dzi-mousebindings.directive';
import { DziOverlaysDrawerDirective } from './directives/dzi-overlays-drawer/dzi-overlays-drawer.directive';
import { DziOverlaysEditorDirective } from './directives/dzi-overlays-editor/dzi-overlays-editor.directive';
import { DziOverlaysViewerDirective } from './directives/dzi-overlays-viewer/dzi-overlays-viewer.directive';
import { DziRulerDirective } from './directives/dzi-ruler/dzi-ruler.directive';
import { DziScalebarDirective } from './directives/dzi-scalebar/dzi-scalebar.directive';

const DZI_DECLARATIONS = [
  DziViewerComponent,
  DziImageFiltersDirective,
  DziKeyBindingsDirective,
  DziMouseBindingsDirective,
  DziOverlaysDrawerDirective,
  DziOverlaysEditorDirective,
  DziOverlaysViewerDirective,
  DziRulerDirective,
  DziScalebarDirective,
];

/**
 * The OpenSeadragon deep-zoom viewer and the directives that extend it.
 * They ship as one module because every directive `@Host()`-injects
 * `DziViewerComponent` — applying one without the viewer is meaningless.
 * Consumers that only render an image can still import this module and use
 * `<ts-dzi-viewer [tileSource]>` alone; the directives are opt-in per usage.
 */
@NgModule({
  imports: [CommonModule],
  declarations: DZI_DECLARATIONS,
  exports: DZI_DECLARATIONS,
})
export class DziViewerModule {}
